/**
 * Presentation Layer - Client Data Filter Utility
 * クライアントデータフィルタリング機能
 */

import type { CsvData } from '../../../../domain/medicalReservation/CsvData';

/**
 * フィルタリング結果
 */
export interface FilterResult {
  /** フィルタリング後のデータ */
  filteredData: CsvData;
  /** 除外されたクライアントデータ件数 */
  excludedCount: number;
}

/**
 * クライアントデータを除外するフィルター
 * 患者名が「クライアント」の行を除外する
 *
 * @param data CSVデータ
 * @returns フィルタリング結果
 */
export const filterClientData = (data: CsvData): FilterResult => {
  // 患者名列のインデックスを検索
  const patientNameIndex = data.headers.findIndex(
    (h) => h === '患者名' || h === 'patient_name'
  );

  // 患者名列が見つからない場合はそのまま返す
  if (patientNameIndex === -1) {
    return { filteredData: data, excludedCount: 0 };
  }

  // 「クライアント」を含む行を除外
  const filteredRows = data.rows.filter(
    (row) => row[patientNameIndex] !== 'クライアント'
  );

  return {
    filteredData: {
      ...data,
      rows: filteredRows,
      totalRows: filteredRows.length,
    },
    excludedCount: data.totalRows - filteredRows.length,
  };
};
